webpackJsonp([1],{

/***/ 19:
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** /~/@buzzfeed/buzzblocks/js/services/metrics/index.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instrument = instrument;

var _mapping = __webpack_require__(/*! ../mapping */ 46);

var VALID_OPTIONS = ['samplingRate'];

/**
 * Increments metric on DataDog.
 * Metric name is constructed from target and value parameters (i.e. 'image.error').
 * @see https://github.com/buzzfeed/mono/blob/master/qr_website_metrics for available metrics and tags.
 * @export
 * @param {String} target - describes what caused metric report.
 * @param {String} value - describes what happened to the metric target.
 * @param {Object?} [tags] - keys and values are metric tag names and values respectively.
 * @param {Object?} [options] - tracking options.
 * @param {Boolean} [options.samplingRate] - forces event to be tracked regardless of sampling configuration.
 * @returns {void}
 * @example instrument('chunk', 'timeout', { name: 'quiz' })
 */
function instrument(target, value) {
  var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (typeof window.bfa !== 'function') {
    if (typeof window.raven !== 'undefined') {
      window.raven.captureException(new Error('Instrumentation tracking issue: BFA is not available'));
    }
    return;
  }

  if (VALID_OPTIONS.some(function (opt) {
    return tags.hasOwnProperty(opt);
  })) {
    options = tags;
    tags = {};
  }

  var _options = options,
      samplingRate = _options.samplingRate;

  var trackingData = {
    data: { target: target, value: value, tags: tags }
  };

  if (samplingRate) {
    if (samplingRate > 1) {
      if (window.BZFD.Config.env === 'dev') {
        console.error('Your sampling rate is above 100%.');
      }
    } else {
      Object.assign(trackingData, { opts: { samplingRate: samplingRate } });
    }
  }

  window.bfa(_mapping.path, trackingData);
}

/***/ }),

/***/ 36:
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** /app/static/js/modules/bounce-policy.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _t3js = __webpack_require__(/*! t3js */ 5);

var _cookies = __webpack_require__(/*! @buzzfeed/buzzblocks/js/services/cookies */ 45);

var _cookies2 = _interopRequireDefault(_cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handles interaction and state storage for the bounce policy
 * (the bar that appears in the top of the site)
 *
 * This is 'visible unless the user hides' (I.e. it'll show
 * without JavaScript enabled and is therefore opt-out to hide)
 */
var BouncePolicy = function () {
  /**
   * @constructor
   * @param context
   */
  function BouncePolicy(context) {
    _classCallCheck(this, BouncePolicy);

    this._element = context.getElement();
    this._bouncePolicyCookie = 'bounce_policy_closed';

    if (!this.getIsClosed()) {
      this._element.classList.remove('js-hidden');
    }
  }

  /**
   * Finds out if this has been closed already
   * @returns bool
   */


  _createClass(BouncePolicy, [{
    key: 'getIsClosed',
    value: function getIsClosed() {
      return !!_cookies2.default.get(this._bouncePolicyCookie, false);
    }

    /**
     * Sets the isClosed state on a cookie for a year
     */

  }, {
    key: 'setIsClosed',
    value: function setIsClosed(isClosed) {
      if (isClosed) {
        _cookies2.default.set({
          name: this._bouncePolicyCookie,
          value: 'opt-out',
          days: 365,
          domain: window.location.hostname
        });
      } else {
        _cookies2.default.remove(this._bouncePolicyCookie, window.location.hostname);
      }
    }

    /**
     * Triggers UI animation to close
     */

  }, {
    key: 'closeAnimated',
    value: function closeAnimated() {
      var _this = this;

      this._element.classList.add('bounce-policy--animation');
      setTimeout(function () {
        return _this._element.classList.add('js-hidden');
      }, 1000);
    }

    /**
     * Handles the on-click behavior
     */

  }, {
    key: 'onclick',
    value: function onclick(e, elem, elemType) {
      if (elemType === 'bounce-close') {
        e.preventDefault();
        this.setIsClosed(true);
        this.closeAnimated();
      }
      return false;
    }
  }]);

  return BouncePolicy;
}();

_t3js.Application.addModule('bounce-policy', function (context) {
  return new BouncePolicy(context);
});

/***/ }),

/***/ 37:
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** /app/static/js/modules/buzzfeed-login.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _t3js = __webpack_require__(/*! t3js */ 5);

var _ajax = __webpack_require__(/*! @buzzfeed/buzzblocks/js/services/ajax */ 44);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handles interaction with the buzzfeed login endpoint to provide
 * a more seamless authentication experience
 */
var BuzzFeedLogin = function () {
  /**
   * @constructor
   * @param context
   */
  function BuzzFeedLogin(context) {
    _classCallCheck(this, BuzzFeedLogin);

    this._element = context.getElement();
    this._fieldset = this._element.querySelector('.fieldset');
    this._feedbackLabel = this._element.querySelector('.form-feedback');
    this._usernameField = this._element.querySelector('[name=username]');
    this._passwordField = this._element.querySelector('[name=password]');
    this._csrfField = this._element.querySelector('[name="gorilla.csrf.Token"]');
    this._onSubmitLock = false;
  }

  /**
   * Sets a text error on the form
   * @param errorMsg (string) the message to display
   */


  _createClass(BuzzFeedLogin, [{
    key: 'setError',
    value: function setError(errorMsg) {
      this._setError();
      this._feedbackLabel.innerText = errorMsg;
    }

    /**
     * Sets an HTML error on the form
     * @param errorMsg (string) the HTML template of the message to display
     */

  }, {
    key: 'setHTMLError',
    value: function setHTMLError(errorMsg) {
      this._setError();
      this._feedbackLabel.innerHTML = errorMsg;
    }

    /**
     * Shows the error on the form
     */

  }, {
    key: '_setError',
    value: function _setError() {
      this.resetFeedback();
      this._feedbackLabel.classList.remove('js-hidden');
      this._fieldset.classList.add('form-fieldset--error');
    }

    /**
     * Sets an success message on the form
     * @param successMsg (string) the message to display
     */

  }, {
    key: 'setSuccess',
    value: function setSuccess(successMsg) {
      this.resetFeedback();
      this._feedbackLabel.innerText = successMsg;
      this._feedbackLabel.classList.remove('js-hidden');
      this._fieldset.classList.add('form-fieldset--success');
    }

    /**
     * Set Loading
     */

  }, {
    key: 'setLoading',
    value: function setLoading() {
      this.resetFeedback();
      this._fieldset.classList.add('form-fieldset--loading');
    }

    /**
     * Set Loaded
     */

  }, {
    key: 'setLoaded',
    value: function setLoaded() {
      this.resetFeedback();
      this._fieldset.classList.remove('form-fieldset--loading');
    }

    /**
     * Removes error/success messages from the form
     */

  }, {
    key: 'resetFeedback',
    value: function resetFeedback() {
      this._feedbackLabel.innerText = '';
      this._feedbackLabel.classList.add('js-hidden');
      this._fieldset.classList.remove('form-fieldset--error');
      this._fieldset.classList.remove('form-fieldset--success');
    }

    /**
     * Listens to all module click events, if it is a click on the
     * button login then trigger onSubmit
     */

  }, {
    key: 'onclick',
    value: function onclick(e, elem, elemType) {
      if (elemType === 'login') {
        e.preventDefault();
        this.onSubmit();
      }
      return false;
    }

    /**
     * Triggered when the form button is clicked via onclick
     * Handles the XHR
     */

  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this = this;

      if (this._onSubmitLock) {
        return Promise.resolve();
      }
      this._onSubmitLock = true;
      this.setLoading();

      var username = encodeURIComponent(this._usernameField.value);
      var password = encodeURIComponent(this._passwordField.value);
      var csrf = encodeURIComponent(this._csrfField.value);
      var buzzfeedLoginEndpoint = '/auth/login/buzzfeed';

      return _ajax2.default.post(buzzfeedLoginEndpoint, {
        type: 'json',
        data: {
          'gorilla.csrf.Token': csrf,
          username: username,
          password: password
        }
      }).then(function (response) {
        _this.setLoaded();
        _this._onSubmitLock = false;
        if (response.error) {
          if (response.html) {
            _this.setHTMLError(response.html);
          } else {
            _this.setError(response.error);
          }
          return;
        }
        if (response.success) {
          _this.setSuccess(response.success);
          window.location = window.redirectUri || '/';
          return;
        }
      }).catch(function () {
        _this._onSubmitLock = false;
        _this.setLoaded();
        _this.setError('unexpected error occurred');
      });
    }
  }]);

  return BuzzFeedLogin;
}();

_t3js.Application.addModule('buzzfeed-login', function (context) {
  return new BuzzFeedLogin(context);
});

/***/ }),

/***/ 38:
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** /app/static/js/tracking/sentry.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _sentry = __webpack_require__(/*! @buzzfeed/buzzblocks/js/services/sentry */ 47);

var _sentry2 = _interopRequireDefault(_sentry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _sentry2.default)({
  env: window.Config.env,
  canary: window.Config.canaryDeploy,
  url: window.Config.sentryUrl,
  sampleRate: 0.05,
  ignoreErrors: []
});

/***/ }),

/***/ 39:
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** /app/static/sass/critical.scss ***!
  \**************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 40:
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** /~/@buzzfeed/buzzblocks/img/apple-touch-icon.png ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/apple-touch-icon.186faa454878ee0d6582ba33b41d2044.png";

/***/ }),

/***/ 41:
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** /~/@buzzfeed/buzzblocks/img/buzzfeed-webapp-logo.png ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/buzzfeed-webapp-logo.0ea3c59fd2aeb164cfdfe77e74ab3aa2.png";

/***/ }),

/***/ 42:
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** /~/@buzzfeed/buzzblocks/img/favicon.ico ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/favicon.5a0c77a8815cfcc67c710199054a55c6.ico";

/***/ }),

/***/ 43:
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** /app/static/js/core-entry.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _t3js = __webpack_require__(/*! t3js */ 5);

__webpack_require__(/*! .../sass/critical.scss */ 39);

__webpack_require__(/*! @buzzfeed/buzzblocks/img/favicon.ico */ 42);

__webpack_require__(/*! @buzzfeed/buzzblocks/img/apple-touch-icon.png */ 40);

__webpack_require__(/*! @buzzfeed/buzzblocks/img/buzzfeed-webapp-logo.png */ 41);

__webpack_require__(/*! ../tracking/sentry */ 38);

__webpack_require__(/*! ../modules/buzzfeed-login.js */ 37);

__webpack_require__(/*! ../modules/bounce-policy.js */ 36);

/**
 * @fileoverview
 * Webpack entry for enhanced-ux version only.
 * Loads all components and initializes the application.
 */
function App() {
  var startT3 = function startT3(config) {
    _t3js.Application.init(config);
  };

  return {
    init: function init() {
      var config = {
        debug: true
      };
      if (document.readyState === 'complete' || document.readyState !== 'loading' && !document.documentElement.doScroll) {
        startT3(config);
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          startT3(config);
        });
      }
    },
    getService: _t3js.Application.getService.bind(_t3js.Application),
    on: _t3js.Application.on.bind(_t3js.Application),
    off: _t3js.Application.off.bind(_t3js.Application),
    broadcast: _t3js.Application.broadcast.bind(_t3js.Application),
    startAll: _t3js.Application.startAll.bind(_t3js.Application),
    start: _t3js.Application.start.bind(_t3js.Application)
  };
}

// start app
window.App = new App();
window.App.init();

/***/ }),

/***/ 44:
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** /~/@buzzfeed/buzzblocks/js/services/ajax/index.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unfetch = __webpack_require__(/*! unfetch */ 136);

var _unfetch2 = _interopRequireDefault(_unfetch);

var _metrics = __webpack_require__(/*! .../metrics */ 19);

var _jsonp = __webpack_require__(/*! jsonp */ 51);

var _jsonp2 = _interopRequireDefault(_jsonp);

var _util = __webpack_require__(/*! .../util */ 48);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a promise, which is rejected after a specified timeout.
 * @param {Number} timeout - number of milliseconds to wait until promise is rejected.
 */

/**
 * A simple JSONP implementation
 * @see https://github.com/webmodules/jsonp
 */
/**
 * Bare minimum fetch polyfill in 500 bytes.
 * @see https://github.com/developit/unfetch
 */
function rejectOnTimeout(timeout) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      return reject({ type: 'timeout', msg: timeout + 'ms timeout exceeded' });
    }, timeout);
  });
}

function errorHandler(_ref) {
  var url = _ref.url;

  return function (err) {
    (0, _metrics.instrument)('xhr', err.type || 'error', { url: url, status: err.status || 0 });
    return Promise.reject(err);
  };
}

/**
 * Promisifies the jsonp implementation
 * @param {String} requestUrl - the request url to be passed to jsonp.
 * @return {Promise} - a promise resolved with the response.
 */
function fetchWithJsonp(requestUrl) {
  return new Promise(function (resolve, reject) {
    (0, _jsonp2.default)(requestUrl, function (err, response) {
      if (err) {
        return reject(err);
      }
      return resolve(response);
    });
  });
}

/**
 * Checks response status code.
 * Resolves when status code is within 200-300 range.
 * Rejects otherwise.
 * @param {Response} response - response object.
 */
function status(response) {
  if (response.ok) {
    return Promise.resolve(response);
  } else {
    return Promise.reject({ type: 'error', status: response.status, statusText: response.statusText });
  }
}

/**
 * Converts response to JSON.
 * @param {Response} response - response object.
 */
function toJson(response) {
  return response.json();
}

/**
 * Converts response to plain text.
 * @param {Response} response - response object.
 */
function toText(response) {
  return response.text();
}

exports.default = {
  /**
   * Performs a GET request to a specified endpoint.
   * @param {String} url - resource URL.
   * @param {Object} options - request options.
   * @param {Object} [options.data={}] - request parameters, are being included in the URL.
   * @param {String} [options.type=json] - expected response type.
   * @param {Object} [options.params={}] - additional fetch parameters.
   * @param {Boolean} [options.skipAuth=false] - flag to add basic auth bypass token to the resource URL.
   * @param {Number} [options.timeout] - maximum time in milliseconds for a request to complete.
   * @return {Promise} - a promise resolved with the response body.
   */
  get: function get(url) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$type = _ref2.type,
        type = _ref2$type === undefined ? 'json' : _ref2$type,
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data,
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params,
        skipAuth = _ref2.skipAuth,
        timeout = _ref2.timeout;

    if (!url) {
      return Promise.reject('URL parameter is required');
    }

    var result = void 0;
    var options = Object.assign({
      credentials: 'same-origin'
    }, params);

    var requestUrl = _util2.default.prepareUrl(url, data);

    if (skipAuth) {
      // @todo remove from util.js service once ajax.js is deprecated
      requestUrl = _util2.default.authBypassWrapper(requestUrl);
    }

    switch (type) {
      case 'json':
        result = (0, _unfetch2.default)(requestUrl, options).then(status).then(toJson);
        break;
      case 'text':
        result = (0, _unfetch2.default)(requestUrl, options).then(status).then(toText);
        break;
      case 'jsonp':
        result = fetchWithJsonp(requestUrl);
        break;
      default:
        result = Promise.reject('Unsupported type ' + type);
    }

    return (timeout ? Promise.race([rejectOnTimeout(timeout), result]) : result).catch(errorHandler({ url: url }));
  },


  /**
   * Performs a POST request to a specified endpoint.
   * @param {String} url - resource URL.
   * @param {Object} options - request options.
   * @param {Object} options.data - request parameters, are being included in the request body.
   * @param {String} [options.type=json] - expected response type.
   * @param {String} [options.params={}] - additional fetch parameters.
   * @param {Boolean} [options.raw=false] - flag to disable converting request parameters to query string key value pairs.
   * @param {Number} [options.timeout] - maximum time in milliseconds for a request to complete.
   * @return {Promise} - a promise resolved with the response body.
   */
  post: function post(url) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref3.data,
        _ref3$type = _ref3.type,
        type = _ref3$type === undefined ? 'json' : _ref3$type,
        _ref3$params = _ref3.params,
        params = _ref3$params === undefined ? {} : _ref3$params,
        _ref3$raw = _ref3.raw,
        raw = _ref3$raw === undefined ? false : _ref3$raw,
        timeout = _ref3.timeout;

    if (!url) {
      return Promise.reject('URL parameter is required');
    }

    if (!data) {
      return Promise.reject('Can not send POST request without data');
    }

    var result = void 0;
    var options = Object.assign({
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      credentials: 'same-origin'
    }, params);

    options.method = 'POST';
    options.body = raw ? data : _util2.default.toQueryString(data);

    switch (type) {
      case 'json':
        result = (0, _unfetch2.default)(url, options).then(status).then(toJson);
        break;
      case 'text':
        result = (0, _unfetch2.default)(url, options).then(status).then(toText);
        break;
      default:
        result = Promise.reject('Unsupported type ' + type);
    }

    return (timeout ? Promise.race([rejectOnTimeout(timeout), result]) : result).catch(errorHandler({ url: url }));
  }
};

/***/ }),

/***/ 45:
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** /~/@buzzfeed/buzzblocks/js/services/cookies/index.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns full regex match, or null if no match
 * @param {String} value, the string which may match *pattern*
 * @param {String} pattern, regex string
 * @returns {String?}
 */
function getFullMatch(value, pattern) {
  var matches = value.match(pattern);
  return matches && matches.length ? matches[0] : null;
}

/**
 * Gives the current hostname, good for mocking purposes
 * @returns {String} hostname
 */
function getCurrentHostname() {
  return window.location.hostname;
}

/**
 * Gives the domain based on the environment
 * @returns {String} domain
 */
function getCookieDomain() {
  return window.BZFD.Config.env === 'prod' ? 'buzzfeed.com' : getCurrentHostname();
}

exports.default = {

  /**
   * Returns domain based on *hostname*.
   * Prefers buzzfeed.com subdomain.
   * Returns generic domain if not a buzzfeed dev|stage|www subdomain.
   * @param hostname {String}
   * @returns {String}
   */
  getBuzzfeedSubdomainOrWildcard: function getBuzzfeedSubdomainOrWildcard(hostname) {
    var subdomainMatch = getFullMatch(hostname, '(dev|stage|www).buzzfeed.(com|io)$');
    if (subdomainMatch) {
      return subdomainMatch;
    }

    return getFullMatch(hostname, '.?[a-z]+.[a-z]+$');
  },


  /**
   * Gets cookie value by name.
   * @param {String} name - cookie name.
   * @param {Object} [defaultValue] - value to return if cookie is not presented.
   * @returns {?Object} - value of the specified cookie or default.
   */
  get: function get(name) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return defaultValue;
  },


  /**
   * Creates cookie with specified properties.
   * @param {Object} args - options for creating a cookie.
   * @param {String} args.name - cookie name.
   * @param {Object} args.value - cookie value.
   * @param {Number} [args.days] - number of days until cookie expires.
   * @param {String} args.domain - the domain to set cookie on
   * @returns {String} document.cookie to be set
   */
  set: function set(_ref) {
    var name = _ref.name,
        value = _ref.value,
        days = _ref.days,
        domain = _ref.domain;

    domain = domain || getCookieDomain();
    var exp = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      exp = '; expires=' + date.toGMTString();
    }

    return document.cookie = name + '=' + value + exp + '; path=/; domain=' + domain;
  },


  /**
   * Removes cookie by name.
   * Sets expiration date on yesterday.
   * @param {String} name - cookie name.
   * @param {String} domain - the hostname of the cookie.
   * @returns {void}
   */
  remove: function remove(name) {
    var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCookieDomain();

    return this.set({
      name: name,
      value: '',
      days: -1,
      domain: domain
    });
  }
};

/***/ }),

/***/ 46:
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** /~/@buzzfeed/buzzblocks/js/services/metrics/mapping.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.path = undefined;

var _get2 = __webpack_require__(/*! lodash/get */ 28);

var _get3 = _interopRequireDefault(_get2);

exports.map = map;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var target = 'target';
var value = 'value';
var tags = 'tags';

var path = exports.path = 'track/website/instrumentation';

function map(mapper) {
  var mapping = mapper.getOrCreateMap(path);
  mapping.addMapTo('type', 'instrumentation');
  mapping.addMapTo('platform', '').mapFrom('data.page.platform');
  mapping.addMapTo('edition', '').mapFrom('data.page.country');
  mapping.addMapTo('category', '').mapFrom(function (src) {
    return (0, _get3.default)(src, 'data.page.category') || 'home';
  });
  mapping.addMapTo(target, '').mapFrom('data.' + target);
  mapping.addMapTo(value, '').mapFrom('data.' + value);
  mapping.addMapTo(tags, '').mapFrom(function (src) {
    return JSON.stringify((0, _get3.default)(src, 'data.' + tags, ''));
  });

  return mapping;
};

/***/ }),

/***/ 47:
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** /~/@buzzfeed/buzzblocks/js/services/sentry/index.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var url = _ref.url,
      _ref$env = _ref.env,
      env = _ref$env === undefined ? window.BZFD.Config.env : _ref$env,
      _ref$canary = _ref.canary,
      canary = _ref$canary === undefined ? window.BZFD.Config.canaryDeploy : _ref$canary,
      _ref$sampleRate = _ref.sampleRate,
      sampleRate = _ref$sampleRate === undefined ? PROD_SAMPLE_RATE : _ref$sampleRate,
      _ref$whitelistUrls = _ref.whitelistUrls,
      whitelistUrls = _ref$whitelistUrls === undefined ? defaultWhitelistUrls : _ref$whitelistUrls,
      _ref$ignoreErrors = _ref.ignoreErrors,
      ignoreErrors = _ref$ignoreErrors === undefined ? [] : _ref$ignoreErrors,
      _ref$dataCallback = _ref.dataCallback,
      dataCallback = _ref$dataCallback === undefined ? function (data) {
    return data;
  } : _ref$dataCallback;


  if (!url && env === 'dev') {
    throw new Error('Missing sentry url. More info: http://bit.ly/2v9diir');
  }

  if (env !== 'prod' && !sentryDebugMode) {
    return;
  }

  _ravenJs2.default.config(url, {
    whitelistUrls: whitelistUrls,
    ignoreErrors: ignoreErrors,
    shouldSendCallback: function shouldSendCallback() {
      if (sentryDebugMode) {
        return true;
      }
      return Math.random() <= sampleRate;
    },
    dataCallback: dataCallback
  }).setTagsContext({ canary: canary }).install();

  window.raven = _ravenJs2.default;
  return _ravenJs2.default; // eslint-disable-line consistent-return
};

var _ravenJs = __webpack_require__(/*! raven-js */ 133);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROD_SAMPLE_RATE = 0.2;
var defaultWhitelistUrls = [/\/static-assets\//];
var sentryDebugMode = window.location.search.indexOf('sentrydebug') > -1;

/**
 * Initialize Sentry for JS error reporting.
 * Sentry is only initialized in production.
 * This also sets raven as a global for access by embeds etc.
 * @export
 * @param {Object} params
 * @param {string} params.url - The sentry unique url
 * @param {string} params.env? - The runtime environment
 * @param {string} params.canary? - Is the deployment type canary?
 * @param {string} params.sampleRate? - The rate at which you sample errors (0 - 1)
 * @param {array} params.whitelistUrls? - An array of URL strings that you want to collect errors on
 * @param {array} params.ignoreErrors? - An array of strings or regexes that you want to ignore
 * @param {array} params.dataCallback? - A transformation function to be run before sending
 * @returns {raven} - the raven-js library
 * @example sentry({ url: 'https://some.url', env: 'dev' })
 */

/***/ }),

/***/ 48:
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** /~/@buzzfeed/buzzblocks/js/services/util/index.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIOS = undefined;

var _isFunction2 = __webpack_require__(/*! lodash/isFunction */ 11);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _get2 = __webpack_require__(/*! lodash/get */ 28);

var _get3 = _interopRequireDefault(_get2);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global BZFD */

exports.bfaTrack = bfaTrack;
exports.getScreenOrientation = getScreenOrientation;

var _t3js = __webpack_require__(/*! t3js */ 5);

var _metrics = __webpack_require__(/*! .../metrics */ 19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Service with some general widely used functions
 */
var util = {};

/**
 * Gets a list of object's enumerable property names.
 * @param {Object} obj - target object.
 * @return {Array} - list of object's keys.
 */
util.getKeys = function (obj) {
  var res;
  if (Object.keys) {
    return Object.keys(obj);
  } else {
    res = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        res.push(key);
      }
    }
    return res;
  }
};

/**
 * Adds module's element id attribute value to the event name.
 * @param {String} origName - original event name.
 * @param {HTMLElement} moduleEl - module's DOM element.
 * @return {String} - name with id value.
 */
util.getUniqueEventName = function (origName, moduleEl) {
  return origName + '-' + moduleEl.id;
};

util.capitalize = function (str) {
  if (typeof str !== 'string') {
    return str;
  } else {
    return str.replace(/\w+/g, function (a) {
      return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
    });
  }
};

util.authBypassWrapper = function (url) {
  if (BZFD.Config.env === 'dev') {
    var hash = 'eca385331012a621bc93fcda0a953a97';
    var char = '?';

    if (util.hasQueryString(url)) {
      char = '&';
    }

    url += char + hash;
  }

  return url;
};

util.hasQueryString = function (url) {
  return url.indexOf('?') > -1;
};

util.removeHash = function (url) {
  url = url + ''; // Convert object to string, if necessary
  if (url.indexOf('#') > -1) {
    return url.substr(0, url.indexOf('#'));
  }
  return url;
};

util.removeQueryString = function (url) {
  url = url + ''; // Convert object to string, if necessary
  if (url.indexOf('?') > -1) {
    if (url.indexOf('#') === -1) {
      return url.substr(0, url.indexOf('?'));
    }
    return url.substr(0, url.indexOf('?')) + url.substr('#', url.length);
  }
  return url;
};

util.getQueryString = function (url) {
  url = util.removeHash(url);
  var querystring = '';
  if (url.indexOf('?') > -1) {
    querystring = url.substr(url.indexOf('?'), url.length); // Contains '?'
  }
  return querystring;
};

util.getHash = function (url) {
  url = url + ''; // Convert object to string, if necessary
  if (url.indexOf('#') > -1) {
    return url.substr(url.indexOf('#'), url.length);
  }
  return '';
};

util.queryStringToObject = function (qs) {
  // Without '?'
  if (qs === '' || qs === undefined || qs === null) {
    return {};
  }
  var params = qs.split('&');
  var pair;
  var obj = {};

  util.each(params, function (i, val) {
    pair = val.split('=');
    if (pair[1] === '') {
      pair[1] = null;
    }
    obj[pair[0]] = pair[1];
  });
  return obj;
};

util.objectToQueryString = function (qs) {
  var str = [];
  util.each(qs, function (key, val) {
    str.push(key + '=' + val);
  });
  return '?' + str.join('&');
};

util.getBaseUrl = function (url) {
  url = util.removeHash(url);
  url = util.removeQueryString(url);
  return url;
};

util.addParams = function (url, keyvals) {
  var qs = util.getQueryString(url); // Contains '?'
  var hash = util.getHash(url); // Contains '#'
  var key;
  var val;

  url = util.removeHash(url);
  url = util.removeQueryString(url);

  qs = util.queryStringToObject(qs.substr(1, qs.length)); // no '?'

  util.each(keyvals, function (i, keyval) {
    key = keyval[0];
    val = keyval[1];
    qs[key] = val;
  });

  return url + util.objectToQueryString(qs) + hash;
};

/**
 * Remove given parameters from a URL string.
 * @param {string} url - a url
 * @param {Array} keys - an array of keys to be deleted
 * @return {string} url - the url without the given params
 */
util.removeParams = function (url, keys) {
  var base = util.getBaseUrl(url);
  var qs = util.getQueryString(url);
  var hash = util.getHash(url);
  var params = util.queryStringToObject(qs.substr(1, qs.length));

  util.each(keys, function (i, key) {
    delete params[key];
  });

  return base + util.objectToQueryString(params) + hash;
};

util.prepareUrl = function (url, data) {
  // Append parameter(s) to url
  var keyvals = [];

  util.each(data, function (key, val) {
    if (typeof val === 'undefined') {
      return;
    }
    keyvals.push([key, encodeURIComponent(val)]);
  });

  return util.addParams(url, keyvals);
};

util.redirect = function (url) {
  if (typeof url === 'string' && url) {
    window.location.href = url;
  }
};

util.openPopup = function (url, options) {
  if (typeof url === 'string' && url) {
    var name = '_blank';
    var wparams = '';

    if (options && options.height && options.width) {
      var sTop = window.screen.height / 2 - options.height / 2;
      var sLeft = window.screen.width / 2 - options.width / 2;
      wparams = 'scrollbars=yes, toolbar=0, status=0, width=' + options.width + ', height=' + options.height + ', top=' + sTop + ', left=' + sLeft;
      name = options.name ? options.name : name;
    }
    window.open(url, name, wparams);
  }
};

/**
 * A generic iterator function, which can be used to seamlessly iterate over both objects
 * and arrays.
 * @todo reorder arguments when iterating an array to match Array.prototype.forEach behavior
 */
util.each = function (iterable, callback) {
  if (Array.isArray(iterable)) {
    iterable.forEach(function (item, idx) {
      return callback(idx, item);
    });
  } else {
    for (var key in iterable) {
      if (iterable.hasOwnProperty(key)) {
        callback(key, iterable[key]);
      }
    }
  }
};

util.extend = __webpack_require__(/*! lodash/merge */ 124);

/**
 *
 * @return {Object} - map of query parameters keys and values
 */
util.getQueryParams = function () {
  var search = window.location.search.substring(1);
  var result = {};
  if (search) {
    search.split('&').forEach(function (param) {
      var p = param.split('=');
      var key = decodeURIComponent(p[0]);
      var value = decodeURIComponent(p.slice(1).join('='));
      result[key] = value;
    });
  }

  return result;
};

/**
 * Adds query parameter to the end of provided URL string.
 * @param {String} [url=location.href] - target URL string.
 * @param {String} key - parameter name.
 * @param {String} val - parameter value.
 * @return {String} - url with specified parameter at the end.
 */
util.addQueryParam = function (url, key, val) {
  url = url || window.location.href;
  return url + (url.split('?')[1] ? '&' : '?') + (key + '=' + val);
};

/* eslint-disable max-len */
/**
 * Change number into shortened format.
 * Example: 125 -> 125; 3456 -> 3,456; 10355 -> 10,4K; 1100123 -> 1.1M;
 * Adapted from
 * https://stackoverflow.com/questions/3177855/how-to-format-numbers-similar-to-stack-overflow-reputation-format
 * @param {Number} val - number to be formatted
 * @returns {String} shortened number
 */
/* eslint-enable max-len */
util.largeNumberNotation = function (val) {
  if (val < 1000) {
    return val;
  } else if (val < 10000) {
    return val.toString().charAt(0) + ',' + val.toString().substring(1);
  } else if (val >= 1000000) {
    return (val / 1000000).toFixed(val % 1000000 !== 0) + 'M';
  }
  return (val / 1000).toFixed(val % 1000 !== 0) + 'K';
};

/* eslint-disable max-len */
/**
 * Splits number with comma by thousands
 * @param {Number} num - number to be formatted
 * @returns {String} - number with commas
 * eslint-disable max-len
 * @see http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
 * eslint-enable max-len
 */
util.numberWithCommas = function (num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * Returns the smallest of numbers.
 * @return {Number} - smallest number.
 */
util.min = function () /*[value1[, value2[, ...]]]*/{
  return Math.min.apply(Math, Array.prototype.filter.call(arguments, function (n) {
    return !isNaN(+n);
  }));
};

/**
 * Converts object to query string params.
 * @param {Object} obj - target object.
 * @return {string} - query string.
 */
util.toQueryString = function (obj) {
  var res = [];
  this.each(obj, function (k, v) {
    if (v !== null && v !== '' && typeof v !== 'undefined') {
      res.push(k + '=' + v);
    }
  });
  return res.join('&');
};

/**
 * Gets a handler for internal events for T3 modules and behaviors.
 * @param {Object} handlerMap - handlers map (key is a message name, value is a handler).
 * @return {Function} - handler for T3 onmessage method.
 */
util.getMessageHandler = function (handlerMap) {
  return function (name, data) {
    var handler = handlerMap[name];
    if (typeof handler === 'function') {
      handler.call(this, data);
    }
  };
};

/**
 * Gets a handler for DOM events for T3 modules and behaviors.
 * @param {Object} handlerMap - handlers map
 * (key is a dataType attribute of the target element, value is a handler).
 * @return {Function} - handler for native DOM events in T3.
 */
util.getEventHandler = function (handlerMap) {
  return function (ev, el, elType) {
    var handler = handlerMap[elType];
    if (typeof handler === 'function') {
      handler.call(this, ev, el);
    }
  };
};

/**
 * Adds leading symbols to a string.
 * @param {String} src - string to pad.
 * @param {String} sym - symbol to add to the src string.
 * @param {Number} len - required result string length.
 * @return {String} - padded src string.
 */
util.padLeft = function (src, sym, len) {
  var str = src.toString();
  var targetLength = len - str.length;
  var acc = '';

  for (var i = 0; i < targetLength; i++) {
    acc += sym;
  }

  return acc + src;
};

/**
 * Converts string into small caps
 * @param {String} str - string to convert.
 * @return {String} - converted string.
 */
util.freeFormFormat = function (str) {
  var uglyStr = str.replace(/["'"“’ ]/g, '').toLowerCase();

  return uglyStr;
};

/**
 * Returns time since text
 * @param {String} date - date string in UTC format `yy:mm:ddThh:mm:ssZ`
 * @return {Object} time since object {'type': '', 'value': '', 'text': ''}
 */
util.timeSince = function (date) {
  var baseFormat = {
    'year': ['year', 'years'],
    'month': ['month', 'months'],
    'day': ['day', 'days'],
    'hour': ['hour', 'hours'],
    'minute': ['minute', 'minutes'],
    'justNow': ['just now']
  };
  var interval;
  var seconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);

  interval = Math.floor(seconds / 31536000);

  if (interval >= 1) {
    return {
      'type': 'year',
      'value': interval,
      'text': interval + ' ' + (interval === 1 ? baseFormat.year[0] : baseFormat.year[1]) + ' ago'
    };
  }

  interval = Math.floor(seconds / 2592000);

  if (interval >= 1) {
    return {
      'type': 'month',
      'value': interval,
      'text': interval + ' ' + (interval === 1 ? baseFormat.month[0] : baseFormat.month[1]) + ' ago'
    };
  }

  interval = Math.floor(seconds / 86400);

  if (interval >= 1) {
    return {
      'type': 'day',
      'value': interval,
      'text': interval + ' ' + (interval === 1 ? baseFormat.day[0] : baseFormat.day[1]) + ' ago'
    };
  }

  interval = Math.floor(seconds / 3600);

  if (interval >= 1) {
    return {
      'type': 'hour',
      'value': interval,
      'text': interval + ' ' + (interval === 1 ? baseFormat.hour[0] : baseFormat.hour[1]) + ' ago'
    };
  }

  interval = Math.floor(seconds / 60);

  if (interval > 1) {
    return {
      'type': 'minute',
      'value': interval,
      'text': interval + ' ' + (interval === 1 ? baseFormat.minute[0] : baseFormat.minute[1]) + ' ago'
    };
  }

  return {
    'type': 'now',
    'value': '',
    'text': baseFormat.justNow[0]
  };
};

util.bulkDelete = function (fields, object) {
  util.each(fields, function (i, val) {
    delete object[val];
  });
};

/**
 * Send data to BF Analytics
 * Example:
 * @param {String} bfaRoute - the route for bfa ex. 'track/click/share'
 * @param {Object} bfaData - formatted object ex. {t:'click:share-button', d:'Facebook'}
 * @returns void
 */
function bfaTrack(bfaRoute) {
  var bfaData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!window.bfa || !(window.bfa instanceof Function) || !window.bfaBinder) {
    return;
  }

  window.bfa(bfaRoute, bfaData);
};
util.bfaTrack = bfaTrack;

/**
 * Checks for screen orientation
 * @return {String} `portrait` or '`landscape`
 */
function getScreenOrientation() {
  if (screen.orientation && screen.orientation.type) {
    return screen.orientation.type.replace('-primary', '');
  } else if (window.orientation) {
    if (Math.abs(window.orientation) === 90) {
      return 'landscape';
    } else {
      return 'portrait';
    }
  } else if (window.matchMedia) {
    if (window.matchMedia('(orientation: portrait)').matches) {
      return 'portrait';
    } else if (window.matchMedia('(orientation: landscape)').matches) {
      return 'landscape';
    }
  }

  return 'landscape';
};
util.getScreenOrientation = getScreenOrientation;

/**
 * Checks browser user agent to detect ipad device
 * @return {Boolean} `true` if ipad device detected, `false` otherwise
 */
util.isIOSIPad = function () {
  var agent = navigator.userAgent.toLowerCase();

  if (agent.match(/ipad/)) {
    return true;
  }

  return false;
}();

/**
 * Checks browser user agent to detect iphone|ipod device
 * @return {Boolean} `true` if iphone|ipod device detected, `false` otherwise
 */
util.isIOSMobile = function () {
  var agent = navigator.userAgent.toLowerCase();

  if (agent.match(/iphone|ipod/)) {
    return true;
  }

  return false;
}();

/**
 * Checks browser user agent to detect iOS device.
 * This is not a reliable long-term method for detecting iOS and should be used sparingly.
 * @return {Boolean} `true` if iOS device detected, `false` otherwise
 */
var isIOS = exports.isIOS = function () {
  return util.isIOSIPad || util.isIOSMobile;
}();
util.isIOS = isIOS;

/**
 * Creates a script tag with the specified URL and appends it to the <head>.
 * @param {String} url - resource URL.
 * @return {Promise} - resolves with the script element when it has loaded.
 */
util.createScript = function (url) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.onload = function () {
      return resolve(script);
    };
    script.onerror = function (evt) {
      (0, _metrics.instrument)('script', 'error', { url: (0, _get3.default)(evt, 'currentTarget.src', '').split('?')[0] });
      reject('Script failed to load');
    };
    script.src = url;
    script.async = true;
    document.head.appendChild(script);
  });
};

/**
 * Recursively strip html tags
 * @param {Object|Array|String} strip - string or object to be stripped
 * @returns {Object|Array|String} - stripped string or object
 */
util.stripHTML = function (strip) {
  var stripped = Array.isArray(strip) ? [] : {};
  var div = document.createElement('div');

  switch (typeof strip === 'undefined' ? 'undefined' : _typeof(strip)) {
    case 'string':
      div.innerHTML = strip;
      return div.textContent || '';
    case 'object':
      util.each(strip, function (key, val) {
        return stripped[key] = util.stripHTML(val);
      });
      return stripped;
  }
  return strip;
};

/**
 * @param {Function} Cls - class that should be extended with mixins
 * @param {...Object|Function} mixin - mixin object or mixin factory;
 * if it's a factory, a parent prototype is passed to it to allow calling parent methods
 * @returns A class that is a descendant of Cls and is extended with methods defined in the mixins
 * Examples of usage: see the unit tests
 */
util.decorateWithMixins = function (Cls) {
  if (!(0, _isFunction3.default)(Cls)) {
    throw new TypeError(Cls + ' is not a function');
  }

  for (var _len = arguments.length, mixins = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    mixins[_key - 1] = arguments[_key];
  }

  mixins.forEach(function (mixin, idx) {
    if (mixin === undefined) {
      throw new TypeError('Mixin at position ' + idx + ' is undefined');
    }
  });

  var chain = [Cls];

  mixins.forEach(function (mixin) {
    var Parent = chain[0];

    var Wrapper = function (_Parent) {
      _inherits(Wrapper, _Parent);

      function Wrapper() {
        _classCallCheck(this, Wrapper);

        return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
      }

      return Wrapper;
    }(Parent);

    ;

    if ((0, _isFunction3.default)(mixin)) {
      mixin = mixin(Parent.prototype);
    }
    Object.assign(Wrapper.prototype, mixin);

    chain.unshift(Wrapper);
  });

  return chain[0];
};

/**
 * Returns instance of unique id generator
 * @param {Number} [start=1] - initial value to increment
 * @return {Function} function that increments its counter on each call and returns that value
 */
util.idGenerator = function () {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  var id = start;
  return function () {
    return id++;
  };
};

/**
 * Make `util` service available in external code via `BZFD.App.getService('util')`.
 * This is used in games, @see https://buzzfeed.atlassian.net/browse/SITE-4776
*/
_t3js.Application.addService('util', function () {
  return util;
});

exports.default = util;

/***/ })

},[43]);


// WEBPACK FOOTER //
// js/core.6be85d8b1f3d9c47bc1b.js